export default __webpack_public_path__ + "static/media/Impact.590979fd.ttf";